import React, { useState, useEffect } from 'react';
import './FloatingIcons.css';
import { WhatsAppIcon, ArrowUpIcon } from '../Icons';

const FloatingIcons = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show scroll-to-top button after scrolling down 300px
      if (window.scrollY > 300) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="floating-icons-container">
      {/* Scroll to Top Icon */}
      <button 
        className={`floating-icon scroll-top-icon ${showScrollTop ? 'show' : ''}`}
        onClick={scrollToTop}
        aria-label="Scroll to top"
      >
        <ArrowUpIcon size={24} color="#FFF" />
      </button>

      {/* WhatsApp Icon */}
      <a 
        href="https://wa.me/919876543210" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="floating-icon whatsapp-icon"
        aria-label="Chat with us on WhatsApp"
      >
        <WhatsAppIcon size={28} color="#FFF" />
      </a>
    </div>
  );
};

export default FloatingIcons;
